import { render, staticRenderFns } from "./ListAvatar.vue?vue&type=template&id=30017c11&scoped=true&"
import script from "./ListAvatar.vue?vue&type=script&lang=js&"
export * from "./ListAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30017c11",
  null
  
)

export default component.exports